import { MenuItem } from '@mui/material';
import { default as Box } from '@mui/material/Box';
import { AppSelectField, FieldInfoMessage } from 'components/form-fields';
import { getTrans } from 'modules/i18n';

export const WorkPreferenceFields = () => (
  <>
    <AppSelectField
      displayValidationError={true}
      data-dd-privacy="mask"
      name="personalDetails.weeklyAvailableHours"
      label={getTrans('cvBuilderPage.personalDetails.form.hoursPerWeek.label')}
      variant="outlined"
      fullWidth
    >
      {Array.from({ length: 13 }, (_, i) => i + 8).map(hours => (
        <MenuItem key={hours} value={hours}>
          {hours}{' '}
          {getTrans(
            'cvBuilderPage.personalDetails.form.hoursPerWeek.label.hoursPerWeek'
          )}
        </MenuItem>
      ))}
    </AppSelectField>
    <Box sx={{ pb: 2 }} />
    <FieldInfoMessage
      helperText={getTrans(
        'cvBuilderPage.personalDetails.form.hoursPerWeek.helperText'
      )}
    />
    <AppSelectField
      displayValidationError={true}
      data-dd-privacy="mask"
      name="personalDetails.stipendBafoeg"
      label={getTrans('cvBuilderPage.personalDetails.form.bafoeg.label')}
      variant="outlined"
      fullWidth
    >
      <MenuItem value="true">
        {getTrans('cvBuilderPage.selection.yes')}
      </MenuItem>
      <MenuItem value="false">
        {getTrans('cvBuilderPage.selection.no')}
      </MenuItem>
    </AppSelectField>
  </>
);
